import React, { Component } from 'react';


class Facebook extends Component {
  componentDidMount() {
    if (window.FB) {
      window.FB.XFBML.parse();
    } else {
      window.fbAsyncInit = function () {
        window.FB.init({
          xfbml: true,
          version: "v18.0",
        });
      };

      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.defer = true;
      script.crossOrigin = "anonymous";
      script.nonce = "fb_plugin";
      document.body.appendChild(script);
    }
  }

  render() {
    return (
      <div
        className="fb-page"
        data-href="https://www.facebook.com/restaurantbronda"
        data-tabs="timeline"
        data-width="500"
        data-height="500"
        data-small-header="true"
        data-adapt-container-width="true"
        data-hide-cover="false"
        data-show-facepile="false"
      >
        <blockquote
          cite="https://www.facebook.com/restaurantbronda"
          className="fb-xfbml-parse-ignore"
        >
          <a href="https://www.facebook.com/restaurantbronda">Ravintola Bronda</a>
        </blockquote>
      </div>
    );
  }
}

export default Facebook;


// WEBPACK FOOTER //
// ./src/components/Facebook.js